module.exports = __webpack_public_path__ + "static/img/sprite.9d24217.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sprite.png
// module id = gWRb
// module chunks = 3